module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-4-mobile.5684a07c.jpg";